import { Flex, useToasts } from '@applyboard/crystal-ui';
import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { NavBars } from '../../components/NavBars';
import { PageHeading } from '../../components/PageHeading';
import { LoadingPage } from '../LoadingPage';
import { AgencyForm } from '../../components/AgencyForm';
import { useGetAgency, useProfile } from '../../hooks';
import { UserType } from '../../clients';

export function EditAgencyPage(): JSX.Element {
  const { id } = useParams();
  const toasts = useToasts();
  const { agencyData, isGetAgencyLoading } = useGetAgency({ id });
  const { profileData: currentSessionUser, isGetProfileLoading: isGetCurrentSessionUserLoading } = useProfile();

  const currentSessionUserIsResolved = !isGetCurrentSessionUserLoading && currentSessionUser;

  const isUnauthorizedUser =
    currentSessionUserIsResolved &&
    currentSessionUser.userType !== UserType.admin &&
    currentSessionUser.userType !== UserType.owner;

  const isAgencyNotFound = currentSessionUserIsResolved && !isGetAgencyLoading && !agencyData;

  useEffect(() => {
    if (isUnauthorizedUser) {
      toasts.warning(`You don't have permission to see this page`);
    }
  }, [isUnauthorizedUser, toasts]);

  useEffect(() => {
    if (isAgencyNotFound) {
      toasts.warning('Agency not found');
    }
  }, [isAgencyNotFound, toasts]);

  if (isGetAgencyLoading || !currentSessionUserIsResolved) {
    return <LoadingPage />;
  }

  if (isUnauthorizedUser) {
    return <Navigate to={'/profiles/agencies'} />;
  }

  if (isAgencyNotFound) {
    return <Navigate to={'/profiles/agencies'} />;
  }

  return (
    <NavBars selectedMenuItem="All Users">
      <Flex p={{ xs: 4, sm: 12 }} direction="column">
        <PageHeading title="Agency details" imageSrc="/user-management-icon.svg" imageAlt="edit agency icon" />
        <AgencyForm agencyData={agencyData} isLoading={isGetAgencyLoading} isReadOnly={true} />
      </Flex>
    </NavBars>
  );
}
